import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import DashboardLayout from "./components/DashboardLayout";
import PrivateRoute from "./components/PrivateRoute";

import Login from "./view/Login";
import Home from "./view/Home";

import DetalleAprendiz from "./components/DetalleAprendiz";
import AsociarEnteVsRector from "./view/AsociarEnteVsJefe";
import AsignacionModulos from "./view/AsignacionModulos";
import ListarActas from "./view/ListarActas";
import ListarAprendices from "./view/ListarAprendices";
import ListarContratos from "./view/ListarContratos";
import ListarEnte from "./view/ListarEnteconformador";
import ListarEProductiva from "./view/ListarEProductiva";
import ListarGuias from "./view/ListarGuiasdeAprendizaje";
import ListarInformesContractuales from "./view/ListarInformesContractuales";
import ListarInstructores from "./view/ListarInstructores";
import ListarMatriculados from "./view/ListarMatriculados";
import ListarMatriculas from "./view/ListarMatriculas";
import ListarResoluciones from "./view/ListarResoluciones";
import ListarTarjetaAprendiz from "./view/ListarTarjetasAsignadas";
import Notificaciones from "./view/Notificaciones";
import Obligaciones from "./view/ObligacionesContractuales";
import RegistrarGuia from "./view/RegisrtarGuiasdeAprendizaje";
import RegistarTestKolb from "./view/RegistarTestKolb";
import RegistrarActas from "./view/RegistrarActas";
import AgendasViaticos from "./view/RegistrarAgendasViatiocos";
import ResgistrarAprendices from "./view/RegistrarAprendices";
import RegistrarBitacoras from "./view/RegistrarBitacoras";
import RegistrarContratos from "./view/RegistrarContratos";
import RegistrarEnte from "./view/RegistrarEnteConformador";
import RegistrarEProductiva from "./view/RegistrarEProductiva";
import RegistrarFirmaAcudiente from "./view/RegistrarFirmaAcudiente";
import RegistrarFirmaAprendiz from "./view/RegistrarFirmaAprendiz";
import RegistrarFirmaInstructor from "./view/RegistrarFirmaInstructor";
import RegistrarInformeContractual from "./view/RegistrarInformeContractual";
import RegisatrarInstructores from "./view/RegistrarInstructores";
import RegistrarMatriculas from "./view/RegistrarMatriculas";
import RegistrarResoluciones from "./view/RegistrarResoluciones";
import RegistrarSegPractica from "./view/RegistrarSegPractica";
import RegistrarTarjetaAprendiz from "./view/RegistrarTarjetaAprendiz";
import RegistrarRegionales from "./view/RegistrarRegionales";
import ListarRegionales from "./view/ListarRegionales";
import ListarCentros from "./view/ListarCentros";
import RegistrarCentros from "./view/RegistrarCentros";
import ListarProgramas from "./view/ListarProgramas";
import RegistrarProgramas from "./view/RegistrarProgramas";
import ListarGrupos from "./view/ListarGrupos";
import RegistrarGrupos from "./view/RegistrarGrupos";
import ListarJefes from "./view/ListarJefes";
import RegistrarJefes from "./view/RegistrarJefes";
import ListarActividad from "./view/ListarActividad";
import RegistrarActividad from "./view/RegistrarActividad";
import RegistrarAsistencia from "./view/RegistrarAsistencia";

function App() {
  return (
    <div className="App">
      <Routes>
        {/* ✅ Público */}
        <Route path="/" element={<Login />} />

        {/* ✅ Protegidas */}
        <Route element={<PrivateRoute />}>
          <Route element={<DashboardLayout />}>
            {/* Redirección por defecto */}
            <Route path="/dashboard" element={<Navigate to="/inicio" replace />} />

            <Route path="/inicio" element={<Home />} />

            <Route path="/instructor" element={<ListarInstructores />} />
            <Route path="/instructor/nuevo" element={<RegisatrarInstructores />} />
            <Route path="/instructor/edit/:id" element={<RegisatrarInstructores />} />

            <Route path="/instructor/registrarcontratos/:id" element={<RegistrarContratos />} />
            <Route path="/instructor/registrarcontratos/editar/:idcontrato" element={<RegistrarContratos />} />
            <Route path="/instructor/listarcontratos/:id" element={<ListarContratos />} />
            <Route path="/instructor/obligaciones/:id" element={<Obligaciones />} />

            <Route path="/instructor/informecontractual/:id" element={<RegistrarInformeContractual />} />
            <Route path="/instructor/informecontractual/editar/:informeId" element={<RegistrarInformeContractual />} />
            <Route path="/instructor/informecontractual/listar/:id" element={<ListarInformesContractuales />} />
            <Route path="/instructor/agendas/:id" element={<AgendasViaticos />} />
            <Route path="/instructor/registrarfirma/:id" element={<RegistrarFirmaInstructor />} />

            <Route path="/aprendiz" element={<ListarAprendices />} />
            <Route path="/aprendiz/nuevo" element={<ResgistrarAprendices />} />
            <Route path="/aprendiz/:id" element={<DetalleAprendiz />} />
            <Route path="/aprendiz/edit/:id" element={<ResgistrarAprendices />} />
            <Route path="/aprendiz/testkolb/registrar/:id" element={<RegistarTestKolb />} />
            <Route path="/aprendiz/testkolb/editar/:testid" element={<RegistarTestKolb />} />
            <Route path="/aprendiz/registrarfirma/:id" element={<RegistrarFirmaAprendiz />} />
            <Route path="/aprendiz/registrarfirma/:idAprendiz/:idAcudiente" element={<RegistrarFirmaAcudiente />} />

            <Route path="/institucional/regional" element={<ListarRegionales />} />
            <Route path="/institucional/regional/edit/:id" element={<RegistrarRegionales />} />
            <Route path="/institucional/regional/nuevo" element={<RegistrarRegionales />} />

            <Route path="/institucional/centro" element={<ListarCentros />} />
            <Route path="/institucional/centro/nuevo" element={<RegistrarCentros />} />
            <Route path="/institucional/centro/edit/:id" element={<RegistrarCentros />} />

            <Route path="/institucional/programas" element={<ListarProgramas />} />
            <Route path="/institucional/programas/nuevo" element={<RegistrarProgramas />} />
            <Route path="/institucional/programas/edit/:id" element={<RegistrarProgramas />} />

            <Route path="/institucional/guias/nuevo/:codPrograma" element={<RegistrarGuia />} />
            <Route path="/institucional/guias/editar/:guiaId" element={<RegistrarGuia />} />
            <Route path="/institucional/guias/listarguias/:codPrograma" element={<ListarGuias />} />

            <Route path="/institucional/grupos" element={<ListarGrupos />} />
            <Route path="/institucional/grupos/nuevo" element={<RegistrarGrupos />} />
            <Route path="/institucional/grupos/edit/:id" element={<RegistrarGrupos />} />

            <Route path="/institucional/actas/nuevo/:fichaGrupo" element={<RegistrarActas />} />
            <Route path="/institucional/actas/editar/:id" element={<RegistrarActas />} />
            <Route path="/institucional/actas/:id" element={<ListarActas />} />

            <Route path="/enteconformador/ente/nuevo" element={<RegistrarEnte />} />
            <Route path="/enteconformador/ente/editar/:id" element={<RegistrarEnte />} />
            <Route path="/enteconformador/ente" element={<ListarEnte />} />

            <Route path="/enteconformador/resoluciones/registrar/:idEnte" element={<RegistrarResoluciones />} />
            <Route path="/enteconformador/resoluciones/editar/:idResolucion" element={<RegistrarResoluciones />} />
            <Route path="/enteconformador/resoluciones/:id" element={<ListarResoluciones />} />

            <Route path="/enteconformador/jefes" element={<ListarJefes />} />
            <Route path="/enteconformador/jefes/nuevo" element={<RegistrarJefes />} />
            <Route path="/enteconformador/jefes/edit/:id" element={<RegistrarJefes />} />

            <Route path="/enteconformador/asociar/jefeinmediato/:id" element={<AsociarEnteVsRector />} />
            <Route path="/enteconformador/asociar/jefeinmediato/editar/:idasociado" element={<AsociarEnteVsRector />} />

            <Route path="/matricula/listarmatriculas" element={<ListarMatriculas />} />
            <Route path="/matricula/registrar" element={<RegistrarMatriculas />} />
            <Route path="/matricula/editar/:id" element={<RegistrarMatriculas />} />
            <Route path="/matricula/listarmatriculados/:id" element={<ListarMatriculados />} />

            <Route path="/actividad/nuevo/:id" element={<RegistrarActividad />} />
            <Route path="/actividad/asistencia/:id" element={<ListarActividad />} />
            <Route path="/asistencia/:id" element={<RegistrarAsistencia />} />

            <Route path="/tarjeta/nuevo" element={<RegistrarTarjetaAprendiz />} />
            <Route path="/tarjeta/listartarjetaaprendiz" element={<ListarTarjetaAprendiz />} />

            <Route path="/etapaproductiva/nuevo" element={<RegistrarEProductiva />} />
            <Route path="/etapaproductiva/registro/:aprendizId/:matriculaId" element={<RegistrarEProductiva />} />
            <Route path="/etapaproductiva/registromasivo/:matriculaId" element={<RegistrarEProductiva />} />
            <Route path="/etapaproductiva/editar/:epracticaId" element={<RegistrarEProductiva />} />

            <Route path="/etapaproductiva/listareproductiva" element={<ListarEProductiva />} />
            <Route path="/etapaproductiva/bitacoras/:etapaId/:aprendizId/:matriculaId" element={<RegistrarBitacoras />} />
            <Route path="/etapaproductiva/bitacoras/registromasivo/:matriculaId" element={<RegistrarBitacoras />} />

            <Route path="/etapaproductiva/seguimiento/registromasivo/:matriculaId" element={<RegistrarSegPractica />} />
            <Route path="/etapaproductiva/seguimiento/:etapaId/:aprendizId/:matriculaId" element={<RegistrarSegPractica />} />

            <Route path="/configuraciones/asignarmodulos" element={<AsignacionModulos />} />
            <Route path="/configuraciones/notificaciones" element={<Notificaciones />} />
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;